<template>
  <div class="overflow-y-scroll w-full h-full">
    <div class="w-full max-w-[1170px] mx-auto px-4 sm:px-6 lg:px-8 mt-10">
    <div class="mb-6 sticky top-0 bg-white z-10 py-2">
      <router-link
        :to="{ name: 'PageContent', params: { contentType: contentType } }"
        class="inline-flex items-center gap-1 text-sm text-blue hover:underline"
      >
        ← Назад
      </router-link>
    </div>
      <div v-if="!content" class="text-center text-gray-500">Загрузка...</div>

      <div v-else>
        <h1 class="text-3xl font-bold mb-6">{{ content.title }}</h1>
        <div class="mb-4 text-sm text-gray-500">
          Категория: {{ content.category_name || 'Не указана' }} |
          Дата: {{ content.created_at }}
        </div>

        <div class="mb-6 flex justify-center">
          <img
            v-if="content.image"
            :src="content.image"
            alt="Cover"
            class="rounded-md max-h-[400px]"
          />
        </div>

        <div v-if="content.uav_catalog" class="bg-blue-50 p-4 rounded-lg mb-6 text-sm space-y-2">
          <h3 class="font-bold text-gray-900 mb-3">Информация о продукции</h3>
          <div v-if="content.uav_catalog.manufacturer" class="flex justify-between">
            <span class="font-medium text-gray-600">Производитель:</span>
            <span class="text-gray-900">{{ content.uav_catalog.manufacturer }}</span>
          </div>
          <div v-if="content.uav_catalog.purpose" class="flex justify-between">
            <span class="font-medium text-gray-600">Назначение:</span>
            <span class="text-gray-900">{{ content.uav_catalog.purpose }}</span>
          </div>
          <div v-if="content.uav_catalog.cost" class="flex justify-between">
            <span class="font-medium text-gray-600">Стоимость:</span>
            <span class="text-gray-900 font-semibold">{{ content.uav_catalog.cost }}</span>
          </div>
          <div v-if="content.uav_catalog.supplier" class="flex justify-between">
            <span class="font-medium text-gray-600">Поставщик:</span>
            <span class="text-gray-900">{{ content.uav_catalog.supplier }}</span>
          </div>
        </div>

        <div class="prose max-w-none" v-html="content.content"></div>

        <CommentsListComponent
          class="mt-5 pb-5"
          v-if="content.slug"
          content-type="content"
          :object-id="content.slug"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CONTENT } from "@/const/uri";
import CommentsListComponent from "@/components/Comments/CommentsList.vue";

export default {
  name: "PageContentDetail",
  components: {
    CommentsListComponent,
  },
  data() {
    return {
      content: null,
    };
  },
  computed: {
    contentType() {
      return this.$route.params.contentType;
    },
    slug() {
      return this.$route.params.slug;
    },
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      try {
        const response = await axios.get(`${API_CONTENT.list}${this.slug}/`, {
          params: {
            content_type: this.contentType,
          },
        });

        if (response.data.code === 0) {
          this.content = response.data.data;
        }
      } catch (error) {
        console.error("Ошибка при загрузке деталей контента:", error);
      }
    },
  },
};
</script>
